import React from "react";
import { Editor } from '@tinymce/tinymce-react';
import {apiRequestWithAuth} from "../../../utils/api";

type MyEditor = {
    label?: string;
    content: string;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    error?: string;
    required?: boolean;
    disabled?: boolean;
    placeholder?: string;
    rows?: number;
};

const MyEditor = ({
  label,
  content,
  onChange,
  onBlur,
  error,
  required = false,
  disabled = false,
  placeholder = '',
  rows = 1,
}: MyEditor) => {

    const handleImageUpload: any = async (blobInfo: any, success: any, failure: any) => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob());
        formData.append("subject", "post_image");
        return new Promise(async (success, failure) => {
            try {
                const res = await apiRequestWithAuth('/media/file', 'POST', formData);
                if (res.messageCode === 200) {
                    success(res.result?.publicPath);
                } else {
                    failure('Upload failed');
                }
            } catch (e) {
                failure('Upload failed');
            }
        });
    };

    return (
        <Editor
            /*apiKey='xn81f0wntrfkrer8io1enrjytxyxmy364zzveel6ozty8zd3'*/
            apiKey='bqserziahyvgh139y9gr3i4wr0vft23it0j304ep1wnibv8t'
            init={{
                plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                images_upload_handler: handleImageUpload,
                automatic_uploads: true,
                images_reuse_filename: true,
                file_picker_types: 'image',
                min_height: 200,
            }}
            value={content}
            onEditorChange={(newValue, editor) => {
                if (onBlur) {
                    onBlur(newValue);
                }
            }}
        />
    );
}
export default MyEditor;
